const params = new URLSearchParams(window.location.search)
const device = params.get('device') || null
const version = params.get('version') || null

function parseBoolean(value, defaultValue = false) {
    try {
        if (value === null) return defaultValue
        return JSON.parse(value.toLowerCase())
    } catch {
        return defaultValue
    }
}

// TODO: re-enable once dynamic device/version routing (WHO/CONF redirect) is validated
// const codeMode = parseBoolean(params.get('codeMode'), false)
// const microPythonMode = parseBoolean(params.get('microPythonMode'), true)
const codeMode = false
const microPythonMode = false

const initialState = {
    currentMode: {
        isCodingMode: codeMode,
        isMicroPythonMode: microPythonMode,
    },
    codes: ``,
}

const reducer = function (state, action) {
    if (typeof state === 'undefined')
        state = JSON.parse(JSON.stringify(initialState))
    switch (action.type) {
        case 'SET_CURRENT_MODE': {
            // TODO: re-enable once dynamic device/version routing (WHO/CONF redirect) is validated.
            // Made a no-op so the app reliably stays in Blocks mode /
            // codeMode=false / microPythonMode=false while that work lands.
            // const currentParams = new URLSearchParams(window.location.search)
            // currentParams.set('codeMode', action.payload.isCodingMode)
            // currentParams.set(
            //     'microPythonMode',
            //     action.payload.isMicroPythonMode
            // )
            // const newUrl =
            //     window.location.pathname + '?' + currentParams.toString()
            // window.history.pushState({}, '', newUrl)
            // location.reload()
            return state
        }
        case 'SET_CODES': {
            return Object.assign({}, state, {
                codes: action.payload,
            })
        }
        case 'RESET_CODES': {
            return Object.assign({}, state, {
                codes: '',
            })
        }

        default:
            return state
    }
}

const setCurrentMode = function (portBusyData) {
    let newPortBusyData = JSON.parse(JSON.stringify(portBusyData))
    return {
        type: 'SET_CURRENT_MODE',
        payload: newPortBusyData,
    }
}

const setCodes = function (codes) {
    return {
        type: 'SET_CODES',
        payload: codes,
    }
}
const resetCodes = function () {
    return {
        type: 'RESET_CODES',
    }
}
export {
    parseBoolean,
    codeMode,
    reducer as default,
    initialState as scriptInitialState,
    setCurrentMode,
    setCodes,
    resetCodes,
}
